import type { TierEntry, TierLimits } from "@signaloid/cloud-compute-engine-client";

export type { TierLimits };
export type TierCatalogEntry = TierEntry;

const tierLimitMembers: Record<keyof TierLimits, null> = {
	ConcurrentTaskCount: null,
	ConcurrentBuildCount: null,
	CloudStorageBytes: null,
	DataDriveCount: null,
	BucketCount: null,
	GatewayCount: null,
	DataSourceCount: null,
	PlotCount: null,
	RegistryStorageBytesMaximum: null,
	CoreCount: null,
	CorePrecisionBits: null,
	CoreReferenceQuality: null,
	CoreMemorySizeBytesMaximum: null,
	ProCoreVariants: null,
	RepositoryCount: null,
	APIAccessCount: null,
	KeyCount: null,
	AuditableZeroDataRetention: null,
	DedicatedSingleTenancyPrivateServerOption: null,
	CoreAvailableMicroarchitectures: null,
	ExecutionTimeInMillisecondsCount: null,
	BuildTimeInMillisecondsCount: null,
};

export const TIER_LIMIT_KEYS = Object.keys(tierLimitMembers);
